import { Box, Button, Menu, MenuItem, Tooltip, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useCallback } from 'react';
import NumberFormat from 'react-number-format';
import styles from './styles';
import { useHistory } from 'react-router-dom';
import { CURRENCY_TYPES, GENDERS, TITLES } from '../../collums-constants/index';
import moment from 'moment';
import CustomerApi from '../../api/customerApi';
import { useSelector, useDispatch } from 'react-redux';
import { hideEmail, hideNumber } from '../../services/helpers/hideInfo';
import { getOrganisationShowPatienInfotSelector } from '../../customSelectors/calendar';
import MembershipModal from './memberships/modals/MembershipModal';
import CancelContinueModal from '../../collums-components/components/common/CancelContinueModal';
import CreateCustomerModal from '../../collums-components/components/common/CreateCustomerModal/CreateCustomerModal';
import { uploadCustomerAvatar } from '../../collums-components/api/CustomerApi';
import { getAge } from '../../services/helpers';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { showCreateCustomerModal } from '../../actions/dayScheduleActions';
import { toastr } from 'react-redux-toastr';
function CustomerHeader(props) {
    const [balance, setBalance] = useState(0);
    const [leadCustomer, setLeadCustomer] = useState(null);

    const [isCreateCustomerConfirmModalOpen, setIsCreateCustomerConfirmModalOpen] = useState(false);
    const [isCreateClientFormOpen, setIsCreateClientFormOpen] = useState(false);
    const [showMembershipModal, setShowMembershipModal] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.has('newMembership');
    });
    const history = useHistory();
    const dispatch = useDispatch();
    const organisation = useSelector(state => state.calendar.organisation);
    const [currency, setCurrency] = useState('£');
    const noShowPatientInfo = useSelector(getOrganisationShowPatienInfotSelector);
    const [anchorEl, setAnchorEl] = useState(null);

    const { classes } = props;

    const handleCloseMenu = () => setAnchorEl(null);

    const shouldListUpdate = useSelector(state => state.invoice.shouldListUpdate);
    /* eslint-disable-next-line */
    const getCustomerBalance = useCallback(() => {
        CustomerApi.getCustomerBalance(props.customer.id).then(res => setBalance(res.balance));
    }, [props.customer]);

    useEffect(() => {
        if (props.customer) getCustomerBalance();
    }, [getCustomerBalance, props.customer]);

    useEffect(() => {
        if (shouldListUpdate) getCustomerBalance();
    }, [getCustomerBalance, shouldListUpdate]);

    const genTitle = customer => {
        const title = customer.title === TITLES.CUSTOM && customer.customTitle ? customer.customTitle : '';
        return title;
    };

    useEffect(() => {
        const currentCurrency = CURRENCY_TYPES.find(type => type.NAME === organisation?.currency);
        setCurrency(currentCurrency ? currentCurrency.SYMBOL : '£');
    }, [organisation]);

    useEffect(() => {
        if (props?.customer?.isLead) {
            CustomerApi.findCustomerByEmail(props.customer.email).then(res => {
                setLeadCustomer(res);
            });
        }
        /* eslint-disable-next-line */
    }, [props?.customer]);

    return (
        <Box
            className="customer-header"
            p={2}
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
        >
            <Typography className={classes.headerTitle}>
                {props.customer
                    ? `${genTitle(props.customer)} ${props.customer.firstName} ${props.customer.surname} ${
                          props.customer.friendlyId
                      }`
                    : ''}
                {props.customer && props.customer.isLead && (
                    <Button
                        className={`${classes.leadBadge} ${props.customer.leadStatus}`}
                        variant="contained"
                        disabled
                    >
                        Lead
                    </Button>
                )}
                {props.customer && props.customer.isLead && leadCustomer?.id && (
                    <Button
                        className={`${classes.customerBadge}`}
                        variant="contained"
                        onClick={() => {
                            window.open(`/customer/${leadCustomer.id}/general`, '_blank');
                        }}
                    >
                        Client
                    </Button>
                )}
                {props.customer && (
                    <>
                        <Button
                            onClick={event => setAnchorEl(event.currentTarget)}
                            style={{
                                marginLeft: '20px',
                                marginTop: '-2px',
                                backgroundColor: '#3083EC',
                                color: 'white',
                                border: 0,
                                textTransform: 'none',
                                padding: '2px 8px',
                                borderRadius: 0
                            }}
                            variant="outlined"
                            endIcon={<ArrowDropDownIcon />}
                        >
                            Action
                        </Button>
                        <Menu
                            id="customer-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleCloseMenu}
                            className={classes.optionsMenu}
                        >
                            {(!props.customer.isLead || leadCustomer?.id) && (
                                <MenuItem
                                    onClick={() => {
                                        const day = new moment().format('DD-MM-YYYY');
                                        const url = props.customer.isLead
                                            ? `/?day=${day}&customer=${leadCustomer.id}&lead=${props.customer.id}`
                                            : `/?day=${day}&customer=${props.customer.id}`;
                                        window.open(url, '_blank');
                                        handleCloseMenu();
                                    }}
                                >
                                    Book appointment
                                </MenuItem>
                            )}
                            {(!props.customer.isLead || leadCustomer?.id) && (
                                <MenuItem
                                    onClick={() => {
                                        const posUrl = JSON.parse(localStorage.getItem('linkCache')).posUrl;
                                        const url = props.customer.isLead
                                            ? `${posUrl}/sale?customer=${leadCustomer.id}&lead=${props.customer.id}`
                                            : `${posUrl}/sale?customer=${props.customer.id}`;
                                        window.open(url, '_blank');
                                        handleCloseMenu();
                                    }}
                                >
                                    New invoice
                                </MenuItem>
                            )}
                            {props.customer.isLead && !leadCustomer?.id && (
                                <MenuItem
                                    onClick={() => {
                                        setIsCreateCustomerConfirmModalOpen(true);
                                        handleCloseMenu();
                                    }}
                                >
                                    Create client
                                </MenuItem>
                            )}
                            {(!props.customer.isLead || leadCustomer?.id) && (
                                <MenuItem
                                    onClick={() => {
                                        setShowMembershipModal(true);
                                        handleCloseMenu();
                                    }}
                                >
                                    Signup membership
                                </MenuItem>
                            )}
                            <MenuItem
                                onClick={() => {
                                    /* eslint-disable no-unused-vars */
                                    const {
                                        id,
                                        _id,
                                        friendlyId,
                                        isLead,
                                        leadStatus,
                                        fromLead,
                                        leadConvertedAt,
                                        ...leadData
                                    } = props.customer;
                                    /* eslint-enable no-unused-vars */
                                    dispatch(showCreateCustomerModal(true, leadData));
                                    handleCloseMenu();
                                }}
                            >
                                New lead
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    history.push(`/customer/${props.customer.id}/communications/email_sms?send=email`);
                                    handleCloseMenu();
                                }}
                            >
                                Send email
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    history.push(`/customer/${props.customer.id}/communications/email_sms?send=sms`);
                                    handleCloseMenu();
                                }}
                            >
                                Send sms
                            </MenuItem>
                        </Menu>
                    </>
                )}
            </Typography>

            <Typography className={classes.headerUnderlineText}>
                {props.customer && props.customer.hasSimilarName ? 'Customer with similar name' : ''}
            </Typography>

            <Typography className={classes.headerText}>
                {props.customer && props.customer.gender !== GENDERS.CUSTOM ? props.customer.gender : ''}
            </Typography>

            <Typography className={classes.headerText}>
                {props.customer && props.customer.dateOfBirth ? props.customer.dateOfBirth.format('DD/MM/YYYY') : ''}
                {props.customer && props.customer.dateOfBirth ? ` (${getAge(props.customer.dateOfBirth)})` : ''}
            </Typography>

            <Typography className={classes.headerText}>
                {noShowPatientInfo ? hideNumber(props?.customer?.mobilePhone) : props?.customer?.mobilePhone || ''}
            </Typography>

            <Typography className={classes.headerText}>
                {noShowPatientInfo ? hideEmail(props?.customer?.email) : props?.customer?.email || ''}
            </Typography>

            {props.customer && !props.customer.isLead && (
                <Box display="flex" alignItems="center">
                    <Typography className={classes.headerText}>Account balance:</Typography>
                    <NumberFormat
                        displayType={'text'}
                        value={balance.toFixed(2)}
                        prefix={currency}
                        renderText={value => {
                            return (
                                <Box
                                    className={
                                        value.indexOf('-') === 0
                                            ? classes.balance
                                            : value === '£0.00'
                                            ? ''
                                            : classes.balancePositive
                                    }
                                    ml={1}
                                    pt={0.25}
                                    pb={0.25}
                                    pr={0.5}
                                    pl={0.5}
                                >
                                    <Typography className={classes.balanceText}>{value}</Typography>
                                </Box>
                            );
                        }}
                    />
                </Box>
            )}

            <Typography className={classes.warnText}>
                {props.customer && props.customer.clinicAlert ? `CLINICAL ALERT - ${props.customer.clinicAlert}` : ''}
            </Typography>

            <Button
                onClick={() => {
                    if (props.customer && props.customer.isLead) {
                        window.location.href = `${JSON.parse(localStorage.getItem('linkCache')).marketingUrl}/leads`;
                    } else {
                        history.push(`/?day=${moment(new Date()).format('DD-MM-YYYY')}`);
                    }
                }}
            >
                <Tooltip title="Close">
                    <Close fontSize="medium" />
                </Tooltip>
            </Button>

            <MembershipModal
                showMembershipModal={showMembershipModal}
                setShowMembershipModal={setShowMembershipModal}
                customer={props.customer}
            />

            {isCreateCustomerConfirmModalOpen && (
                <CancelContinueModal
                    setOpen={() => setIsCreateCustomerConfirmModalOpen(false)}
                    onContinue={async () => {
                        if (!leadCustomer?.id) {
                            setIsCreateCustomerConfirmModalOpen(false);
                            setIsCreateClientFormOpen(true);
                        } else {
                            await CustomerApi.updateCustomerLeadStatus(props.customer.id, null, false).then(res => {
                                setLeadCustomer(res.data.customer);
                                if (props.reloadCustomer) props.reloadCustomer(props.customer.id);
                                toastr.success('Client unarchived');
                            });
                        }
                    }}
                    closeOnBlur={false}
                    title="Create client from lead"
                    contentText={
                        !leadCustomer?.id
                            ? 'A new client will be created so that you can book appointments etc. This lead will not be deleted.'
                            : 'Customer already exists but is archived. Customer will be unarchived'
                    }
                />
            )}
            {isCreateClientFormOpen && (
                <CreateCustomerModal
                    isCreateCustomerModalOpen={true}
                    isCreateCustomerModalAllowLead={false}
                    isCreateCustomerModalAllowCustomer={true}
                    hideCreateCustomerModal={() => setIsCreateClientFormOpen(false)}
                    persistCustomer={async (data, file, clinic) => {
                        try {
                            const result = await CustomerApi.postCustomer({
                                ...data,
                                addAsLead: false,
                                fromLead: props.customer.id,
                                leadConvertedAt: new Date(),
                                clinics: clinic ? [clinic] : undefined
                            });
                            if (file && result.data?.id) {
                                await uploadCustomerAvatar(result.data.id, file);
                            }
                            setLeadCustomer(result.data);
                            if (props.reloadCustomer) props.reloadCustomer(props.customer.id);
                            toastr.success('Client created');
                        } catch (err) {
                            toastr.error(err?.response?.data?.message || 'Failed to create client');
                            return err;
                        }
                    }}
                    reloadCustomerList={() => {}}
                    clinic={localStorage.getItem('currentClinic')}
                    initialCustomerData={{
                        firstName: props.customer.firstName,
                        surname: props.customer.surname,
                        middleName: props.customer.middleName,
                        email: props.customer.email || props.customer.leadEmail,
                        dateOfBirth: props.customer.dateOfBirth,
                        mobilePhone: props.customer.mobilePhone,
                        otherPhone: props.customer.otherPhone,
                        title: props.customer.title,
                        gender: props.customer.gender,
                        address1: props.customer.address1,
                        address2: props.customer.address2,
                        city: props.customer.city,
                        county: props.customer.county,
                        country: props.customer.country,
                        postal: props.customer.postal || props.customer.postCode,
                        referralSource: props.customer.referralSource,
                        referredBy: props.customer.referredBy,
                        prevSurname: props.customer.prevSurname,
                        aka: props.customer.aka,
                        ethnicity: props.customer.ethnicity,
                        nhsNumber: props.customer.nhsNumber,
                        passportId: props.customer.passportId,
                        occupation: props.customer.occupation,
                        height: props.customer.height,
                        weight: props.customer.weight
                    }}
                />
            )}
        </Box>
    );
}

CustomerHeader.propTypes = {
    classes: PropTypes.object.isRequired,
    customer: PropTypes.object,
    reloadCustomer: PropTypes.func
};

export default withStyles(styles)(CustomerHeader);
